module.exports = __webpack_public_path__ + "static/pannonia-illust-602d5c9b08989ce6bf9475a60d315bd7.jpg";